/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_Request_TitleInputs */

const en_endpoint_reference_request_title = /** @type {(inputs: Endpoint_Reference_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request body`)
};

const zh_hans1_endpoint_reference_request_title = /** @type {(inputs: Endpoint_Reference_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求体`)
};

const pt_br2_endpoint_reference_request_title = /** @type {(inputs: Endpoint_Reference_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo da requisição`)
};

const es_endpoint_reference_request_title = /** @type {(inputs: Endpoint_Reference_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerpo de la solicitud`)
};

const fr_endpoint_reference_request_title = /** @type {(inputs: Endpoint_Reference_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corps de la requête`)
};

const de_endpoint_reference_request_title = /** @type {(inputs: Endpoint_Reference_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request-Body`)
};

const ru_endpoint_reference_request_title = /** @type {(inputs: Endpoint_Reference_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тело запроса`)
};

const it_endpoint_reference_request_title = /** @type {(inputs: Endpoint_Reference_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo della richiesta`)
};

/**
* | output |
* | --- |
* | "Request body" |
*
* @param {Endpoint_Reference_Request_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_request_title = /** @type {((inputs?: Endpoint_Reference_Request_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_Request_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_request_title(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_request_title(inputs)
	if (locale === "es") return es_endpoint_reference_request_title(inputs)
	if (locale === "fr") return fr_endpoint_reference_request_title(inputs)
	if (locale === "de") return de_endpoint_reference_request_title(inputs)
	if (locale === "ru") return ru_endpoint_reference_request_title(inputs)
	if (locale === "it") return it_endpoint_reference_request_title(inputs)
	return en_endpoint_reference_request_title(inputs)
});